import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';
import { Grid } from '@alfa-bank/site-grid-universal';
import { Link } from '@alfa-bank/site-link';

import { CopyLinkIcon } from '../icons/copy-link-icon';
import { VKIcon } from '../icons/vk-icon';
import { TelegramIcon } from '../icons/telegram-icon';
import type { ILinkSharingProps } from '../models';
import { useLinkSharingContext } from '../copy-link-provider/component';
import { ICON_FILL_DESKTOP } from '../../../constants';
import { sendShareLinkAnalytics } from '../../../helpers/analytics';

import styles from './desktop.css';

export const LinkSharingDesktop: FC<ILinkSharingProps> = ({ analytics, title, url }) => {
    const { copyContent } = useLinkSharingContext();

    return (
        <Grid alignment="center" collapse columnsWidth={[null, 16, null, 12, null, 12, null]}>
            <Text kind="caption" styler={{ margin: 0 }} view="primary-medium">
                Поделиться
            </Text>
            <></>
            <Link
                className={cn(styles.external, styles.icon)}
                dataTestId="link-sharing"
                noUnderline
                onClick={() => {
                    copyContent(url);
                    sendShareLinkAnalytics('Скопировать ссылку', analytics?.shareLink);
                }}
                pseudo
                target="_blank"
            >
                <CopyLinkIcon fill={ICON_FILL_DESKTOP} />
            </Link>
            <></>
            <Link
                className={cn(styles.external, styles.icon)}
                dataTestId="vk-sharing"
                href={`http://vk.com/share.php?url=${url}`}
                noUnderline
                onClick={() => sendShareLinkAnalytics('VK', analytics?.shareLink)}
                target="_blank"
            >
                <VKIcon fill={ICON_FILL_DESKTOP} />
            </Link>
            <></>
            <Link
                className={cn(styles.external, styles.icon)}
                dataTestId="tg-sharing"
                href={`https://t.me/share/url?url=${url}&text=${title}`}
                noUnderline
                onClick={() => sendShareLinkAnalytics('Telegram', analytics?.shareLink)}
                target="_blank"
            >
                <TelegramIcon fill={ICON_FILL_DESKTOP} />
            </Link>
        </Grid>
    );
};
